import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, HostBinding, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { Charity } from '@domains';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective } from '@rspl-ui';

@Component({
  selector: 'app-categorize-help-dialog',
  templateUrl: './categorize-help-dialog.component.html',
  styleUrls: ['./categorize-help-dialog.component.scss'],
  imports: [
    FxLayoutDirective,
    FxLayoutGapDirective,
    FxFlexDirective,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    FxLayoutAlignDirective,
  ],
})
export class CategorizeHelpDialogComponent {
  @HostBinding('style.display') display = 'flex';
  @HostBinding('style.height') height = '100%';
  constructor(
    public reference: MatDialogRef<CategorizeHelpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: { charity: Charity; small: { title: string; description: string } },
  ) {}
}
